import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Selection,
    Scrolling,
    Export,
    Editing,
    Summary,
    GroupItem,
    TotalItem
} from 'devextreme-react/data-grid';
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import CustomStore from 'devextreme/data/custom_store';
import Request from "../../components/api/Request";
import { showToast, parseDate, hasRole, parseApiDate } from "../../utils/Utils";
import * as Utils from '../../utils/Utils';
import { ToastType } from "../../constants/Constants";
import * as AppActions from '../../actions/AppActions';
import Box, {
    Item
} from 'devextreme-react/box';
import './CariDonemFinansRapor.scss';
import CariDonemDomainFinansOzetRapor from './CariDonemDomainFinansOzetRapor';

const CariDonemDomainFinansRapor = (props) => {

    const dispatch = useDispatch();

    const [formYetki, setFormYetki] = useState(
        {
            cariDonemRaporDomainListele: Utils.hasRole("cariDonemFinansRapor|cariDonemFinansRapor|cariDonemRaporDomainListele"),
            export: Utils.hasRole("cariDonemFinansRapor|cariDonemFinansRapor|cariDonemExcelExport"),
            cariDonemRaporDomainOzetList: Utils.hasRole("cariDonemFinansRapor|cariDonemFinansRapor|cariDonemRaporDomainOzetList"),
        });

    const [store, setStore] = useState(null);
    const [cariDonemOzetRaporDomainPopupForm, setCariOzetDonemRaporDomainPopupForm] = useState({ popupState: false });

    useEffect(() => {
        setStore(getStore());
    }, [])

    function showOzetPopup(data) {

        setCariOzetDonemRaporDomainPopupForm({ popupState: true, data: data })     
    }
    function hideCariOZetDonemRaporDomainPopupForm() {
        setCariOzetDonemRaporDomainPopupForm({ popupState: false }) 
    }


    let dataGrid = null;

    const getStore = () => {
        let tempGrid = dataGrid;

        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {
                console.log("loadOptions", loadOptions);
                if (loadOptions.searchOperation == undefined) {
                    return;
                }

                let filterArr = [];

                filterArr.push({
                    property: "cariDonemRapor.id",
                    operator: "IN",
                    value: props.data.cariDonemRaporIdList,
                    type: "Long"
                });


                let params = "filter=" + JSON.stringify(filterArr);
                params = encodeURI(params);

                if (tempGrid != null && tempGrid.instance != null) {
                    tempGrid.instance.clearSelection();
                }

                const request = new Request("/cariDonemFinansRapor/getCariDonemRaporDomainList?" + params, "GET");

                return request.run()
                    .then(response => {
                        if (response.data) {
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }

    const exportExcel = () => {
        exportExcelByPersonel(false);
    }
    const exportExcelTumListe = () => {
        exportExcelByPersonel(true);
    }

    function exportExcelByPersonel(tumPersonel) {

        let data = {
            domainIdList: [],
            tumPersonel: tumPersonel,
            cariDonemRaporDomainIdList: [],
            baseUrl :window.location.hostname
        }

        dataGrid.instance.getSelectedRowsData().map(sd => {
            data.cariDonemRaporDomainIdList.push(sd.id);
        });

        if (data.cariDonemRaporDomainIdList.length == 0) {
            showToast('Firma Seçiniz', ToastType.ERROR, 500);
            return;
        }

        const request = new Request("/cariDonemFinansRapor/getCariDonemExcelFile", "POST", data);
        dispatch(AppActions.setLoading(true, "Dosya İndiriliyor.."));
        request.run().then((response, e, f) => {
            dispatch(AppActions.setLoading(false, ""));
            if (response && response.data && response.data.data) {
                if (response.data.data.success) {

                    if (response.data.data.fileName.length > 50) {
                        response.data.data.fileName = response.data.data.fileName.substring(0, 50);
                    }

                    let base64File = response.data.data.file;
                    const href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64File;
                    var a = window.document.createElement('a');
                    a.download = response.data.data.fileName + '.xlsx';
                    a.href = href;
                    a.click();
                    a.href = '';

                    showToast('Belge başarılı bir şekilde yüklendi', ToastType.INFO, 500);

                } else {

                    showToast(response.data.data.mesaj, ToastType.WARNING, 500);

                }

            }
        });

    }



    return (
        <div >
            <DataGrid
                className="cariDonemDomainFinansRaporGrid"
                ref={ref => dataGrid = ref}
                width="100%"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                columnAutoWidth={false}
            >
                <FilterRow visible={true} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging enabled={false} />
                <Selection mode="multiple" selectAllMode="page" showCheckBoxesMode="onClick" deferred={false} />

                <Column type="buttons" caption={'İşlem'}
                    buttons={[
                        { 
                            hint: 'Cari Donem Personel Detay', 
                            icon: 'alignjustify', 
                            visible: () => { return formYetki.cariDonemRaporDomainOzetList },
                            onClick: (e) => { showOzetPopup(e.row.data); } 
                        },
                    ]}
                />

                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} allowEditing={false} />
                <Column dataField={'domain.name'} width={400} caption={'Firma'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField="cariDonemRapor.donem.donem" width={80} caption={'Dönem'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField="hesapToplamFark" width={120} caption={'Fark'} dataType="string" visible={true} allowEditing={false} />

                <Column dataField="domainSozlesme" width={60} caption={'Sözleşme'} dataType="string" visible={true} allowEditing={false} /> 
                <Column dataField="calisanSayi6111" width={60} caption={'6111 Sayı'} dataType="string" visible={true} allowEditing={false} /> 
                <Column dataField="calisanSayi7103" width={60} caption={'7103 Sayı'} dataType="string" visible={true} allowEditing={false} /> 

                <Summary  >
                    {/* <GroupItem
                        column="hesapToplamFark"
                        summaryType="sum"
                        valueFormat="decimal"
                        showInGroupFooter={true}
                        alignByColumn={true}
                        displayFormat="Toplam: {0} TL" /> */}
                    <TotalItem
                        column="hesapToplamFark"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0} TL" 
                    />
                   
                </Summary>

            </DataGrid>

            <Box direction="row" width="100%" height={25}>
                <Item ratio={1}>
                    <Button
                        width="99%"
                        text="Excel Export"
                        type="success"
                        stylingMode="contained"
                        visible={formYetki.export}
                        onClick={exportExcel}
                    />
                </Item>
                <Item ratio={1}>
                    <Button
                        width="100%"
                        text="Excel Export(Tüm Liste)"
                        type="success"
                        stylingMode="contained"
                        visible={formYetki.export}
                        onClick={exportExcelTumListe}
                    />
                </Item>
            </Box>

            <Popup
                visible={cariDonemOzetRaporDomainPopupForm.popupState}
                onHiding={hideCariOZetDonemRaporDomainPopupForm}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title="   Cari Dönem Özet Finans Rapor Formu"
                width={900}
                height={560}
            >
                <div>
                    {cariDonemOzetRaporDomainPopupForm.popupState ? <CariDonemDomainFinansOzetRapor hide={hideCariOZetDonemRaporDomainPopupForm} data={cariDonemOzetRaporDomainPopupForm.data} dataType={"finansRaporDomain"} /> : null}
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideCariOZetDonemRaporDomainPopupForm}
                    />
                </div>
            </Popup>

        </div>
    )
}

export default CariDonemDomainFinansRapor;
